export const META_KEY     = 'meta';
export const ELEMENTS_KEY = 'elements';
export const LINES_KEY    = 'lines';

export const yMeta     = (doc) => doc.getMap(META_KEY);
export const yElements = (doc) => doc.getMap(ELEMENTS_KEY);
export const yLines    = (doc) => doc.getMap(LINES_KEY);
